import React from "react"
import BasicHero from "../../components/basic-hero"
import Calendly from "../../components/calendly/calendly"
import CTARow from "../../components/cta-row"
import { HandleImages } from "../../components/functions"
import Layout from "../../components/layout"
import Resource from "../../components/resource"
import ResourcesWrapper from "../../components/resources-wrapper"
import SEO from "../../components/seo"
import { seodata } from "../../components/seo-data"
import SimpleSlide from "../../components/simple-slide"
import SimpleSlider from "../../components/simple-slider"
import SocialSlider from "../../components/social-slider"

import Infographic from "../../components/hr-infographic"

var image
var content = {
  hero: {
    title: <span>Assess and Retain Cyber Security Talent</span>,
    text: (
      <span>

<h4>How do you find top cyber security talent for your company? </h4>

<h4>How do you ensure new employees have the skills they need to succeed in a new job role?</h4>

<h4>Do you have a platform to effectively test applicant's cyber capabilities?</h4>

      </span>
    ),
  },

  hero2:{
      title:'How can you use Project Ares for cyber candidate skill assessment? ',
      text:(     <span>   <p><strong>For example:</strong> If you’re hiring for an entry level Cyber Defense Analyst role, you might list the following tasks

      to have the candidate demonstrate skills in reconnaissance, sensor tuning, log aggregation and query, and network traffic analysis.</p>
      <ul>
      
      <li>Analyze network traffic using Wireshark</li>
      
      <li>Develop intrusion detection rules for Snort</li>
      
      <li>Analyze a network security incident using packet capture utilities</li>
      </ul>
      <p>
      This could be followed by a more open-ended scenario in Project Ares to analyze network traffic, identify malicious attacks on a network, stop the exfiltration and then analyze the extent of the data loss. The candidate’s success can be measured in if/how hints are used, their overall scoring on tasks, and success against objectives.</p></span>),      
  },

  calendly: {
    text: <span>We'd love to learn about your business or institution.<br/>  Schedule a consultation with us now.</span>,
  },

  cta1: {
    title: "Hire with Confidence and Retain Top Talent",
    text:
      " Combat the growing skills shortage with immersive candidate skills assessment tools.",
    url:
      "https://staging.circadence.com/wp-content/uploads/2020/08/HR-Hire-with-Confidence-v2.pdf",
    cta: "Download Now",
  },
  
  cta2: {
    title: "Invest in your cyber security candidates and talent!  ",
    text:
      "Learn more about Project Ares plans to keep cyber talent acquisition and retention processes formalized.",
    url:
      "/project-ares",
    cta: "Learn More",
  },
  social: {
    social1: {
      image: "",
      title: "",

      text: (
        <span>
        Better understanding these skills gaps and issues with hiring and retention can help the industry more effectively drive innovative strategies and tactics to address and overcome them.
          <span className="source">
          - retired Brigadier General Greg Touhill, ISACA board director, and President of the AppGate Federal Group.
          </span>
        </span>
      ),
      url: "/hr",
    },
  },
  //URL NEEDS UPDATE!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  resources: {
    resource1: {
      title: "Gamification for Cyber Professional Development",
      text:
        "Learn why gamified learning can support skills training and acquisition for today’s cyber security professionals.",
      url:
        "https://marketing.circadence.com/acton/attachment/36273/f-1ebf399b-baed-420b-a651-3156c6cf248c/1/-/-/-/-/Gamification%20Fact%20Sheet%20%28links%20to%20gamification%20blog%20post%29.pdf",
    },
    resource2: {
      title: "3 Ways Companies can Improve Talent Acquisition Process",
      text:
        "Strategies for finding qualified candidates in cyber security.",
      url:        "/blog/3-ways-tech-companies-can-improve-the-talent-acquisition-process/",
    },
    resource3: {
      title: "Involta Improves Cyber Team Training with Project Ares",
      text:
        "Read how this MSSP helped their cyber team upskills continuously to stay on top of the latest threats.",
      url:
        "https://staging.circadence.com/wp-content/uploads/2020/03/New-Involta-Case-Study-FINAL.pdf",
    },
  },
  simple: {
    simple1: {
      text: <span><strong>Evaluate Candidates in Real-Time</strong> with 24/7 browser access to on-demand, real-world scenario activities. </span>,
    },
    simple2: {
      text:
      <span><strong>Assess cyber competencies</strong> against other candidates and co-workers. </span>,
    },
    simple3: {
      text:
      <span><strong>Examine a candidate’s strategic approach</strong> to cyber security practices with problem-solving exercises. </span>,
    },
    simple4: {
      text:
      <span><strong>Retain top talent</strong> with persistent training access to grow in skill and open doors of opportunity for career advancement. </span>,
    },
   
  },
}

class LearnPage extends React.Component {
  render() {
    return (
      <Layout><SEO title={seodata.hr.title} description={seodata.hr.description} keywords={seodata.hr.keywords} />
        <BasicHero
          title={content.hero.title}
          text={content.hero.text}
          image={<HandleImages name="humanResources" />}
        />

    <Infographic/>
<Calendly text={content.calendly.text} inv={true} bgColor={"bright-blue"} />

                
<SocialSlider>
    <SimpleSlide   image={<HandleImages name="gov" />} text={content.social.social1.text} />
   
 

        </SocialSlider>
        <CTARow
          title={content.cta1.title}
          text={content.cta1.text}
          cta={content.cta1.cta}
          url={content.cta1.url}
          inv={false}
          bgColor={"deep-blue"}
          image={"document"}
        />
 
 <h3>Additional Resources </h3>
 
        <ResourcesWrapper>
          <Resource
            image={<HandleImages name={"gamification"} />}
            title={content.resources.resource1.title}
            text={content.resources.resource1.text}
            url={content.resources.resource1.url}
          />
          <Resource
            image={<HandleImages name={"manWomanComputer"} />}
            title={content.resources.resource2.title}
            text={content.resources.resource2.text}
            url={content.resources.resource2.url}
          />
          <Resource
            image={<HandleImages name={"manHeadset"} />}
            title={content.resources.resource3.title}
            text={content.resources.resource3.text}
            url={content.resources.resource3.url}
          />
        </ResourcesWrapper>


        <BasicHero
          title={content.hero2.title}
          text={content.hero2.text}
          image={<HandleImages name="womanScreen" />}
        />




        <SimpleSlider>
          <SimpleSlide
            image={<HandleImages name={"pAScreen1"} />}
            text={content.simple.simple1.text}
          />
          <SimpleSlide
            image={<HandleImages name={"pAScreen2"} />}
            text={content.simple.simple2.text}
          />
          <SimpleSlide
            image={<HandleImages name={"pAScreen3"} />}
            text={content.simple.simple3.text}
          />
          <SimpleSlide
            image={<HandleImages name={"pAScreen4"} />}
            text={content.simple.simple4.text}
          />
         
        </SimpleSlider>
        <br />
    

        <CTARow
          title={content.cta2.title}
          text={content.cta2.text}
          cta={content.cta2.cta}
          url={content.cta2.url}
          
          bgColor={"bright-blue"}
          image={"laptop"}
        />


      </Layout>
    )
  }
}

export default LearnPage
